import axios from 'axios'

const authAxios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// Interceptor for access_token authorization
authAxios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response) {
    // if (error.response.status === 400) {
    //   window.location.href = '/accounts/login/'
    // }
    if (error.response.data) {
      return Promise.reject(error.response)
    }
  }
  return Promise.reject(error.response)
})

export default authAxios
